module.exports = __webpack_public_path__ + "img/Free Response 09.1804105f.png";